import PressHero from "./components/PressHero";
import PressFeatured from "./components/PressFeatured";
import PressGrid from "./components/PressGrid";
import NewsSubscribe from "@/pages/news/components/NewsSubscribe";

export default function PressReleasePage() {
  return (
    <main className="min-h-screen">
      <title>Press Releases | Textile Innovation Exchange</title>
      <meta
        name="description"
        content="Official press releases, partnership announcements, and milestone updates from Textile Innovation Exchange (TIE)."
      />
      <meta
        property="og:title"
        content="Press Releases | Textile Innovation Exchange"
      />
      <meta
        property="og:description"
        content="Official press releases and partnership announcements from Textile Innovation Exchange."
      />
      <meta property="og:url" content="https://textileinnovationexchange.com/press-release" />
      <meta name="twitter:title" content="Press Releases | Textile Innovation Exchange" />
      <meta
        name="twitter:description"
        content="Official press releases and partnership announcements from Textile Innovation Exchange."
      />
      <PressHero />
      <PressFeatured />
      <PressGrid />
      <NewsSubscribe />
    </main>
  );
}